import Environment from "../utils/Environment";
import axios from 'axios';
import { parseErrorMessages } from "../utils/ErrorUtils";
import { 
  transformAndFilterRows, 
  validateIN02LoadGroups, 
  prepareFormData, 
  getApiConfig,
  RowData
} from './JsonProcessingUtils';

const handleJsonUpload = async (
  selectedDC: string,
  tabType: string,
  resetValues: () => void,
  rows: RowData[],
  rowCount: number,
  setIsUploading: (value: boolean) => void,
  showSuccess: (message: string) => void,
  showError: (message: string, fullErrors?: string[]) => void,
  onWaveRunning?: (waveData: any) => void,
  isProceed: boolean = false,
  userId?: string,
  createdtimestamp?: string
) => {
  const formData = new FormData();
  formData.append('dcName', selectedDC);
  if (tabType === 'IN02') {
    formData.append('isProceed', String(isProceed));
  }

  // Transform and filter rows using shared utility
  const filteredRows = transformAndFilterRows(rows, tabType);

  // Validate Load Group fields for IN02 tab type
  if (tabType === 'IN02') {
    const validation = validateIN02LoadGroups(filteredRows, selectedDC, Environment);
    if (!validation.isValid) {
      setIsUploading(false);
      showError(validation.errorMessage!);
      return;
    }
  }

  // Prepare form data for API submission
  const data = prepareFormData(filteredRows, selectedDC);
  // Append the isProceed flag to the prepared form data
  if (tabType === 'IN02') {
    data.append('isProceed', String(isProceed));
  }
  if (userId) {
    data.append('createduser', userId);
  }
  if (createdtimestamp) {
    data.append('createdtimestamp', createdtimestamp);
  }
  
  // Get upload API configuration based on selected DC and tab type
  const { apiEndpoint: jsonUploadAPI, fileTypeLabel } = getApiConfig(tabType, 'upload', Environment, selectedDC);
  
  console.log(`Endpoint called for ${tabType} JSON upload:`, jsonUploadAPI);
  setIsUploading(true);
  try {
    console.log('Data being sent:');
    data.forEach((value, key) => {
      console.log(`${key}: ${value}`);
    });
    const response = await axios.post(jsonUploadAPI || '', data);
    console.log('Response:', response);

    // Condition 1: Check for wave running response from the 'data' object in the response
    if (response.data && response.data.waveStatusApiResponseList && onWaveRunning) {
      // If wave list is present, call the callback
      onWaveRunning(response.data);
    } else if (response.status === 200) {
      // If no wave is running, treat as a direct success
      resetValues();
      showSuccess(`${fileTypeLabel} Data Uploaded successfully - ${filteredRows.length} rows processed - No Errors found`);
    } else {
      const errorMessage = `${fileTypeLabel} Data Upload failed (${filteredRows.length} rows): ` + response.data;
      const parsedErrors = parseErrorMessages(response.data);
      if (parsedErrors.length > 1) {
        showError(errorMessage, parsedErrors);
      } else {
        showError(errorMessage);
      }
    }
  } catch (err: unknown) {
    console.log('Error:', err);
    
    const error = err as { response?: { data: string }; request?: unknown; message?: string };
    
    if (error.response) {
      const errorMessage = `${fileTypeLabel} Data Upload failed (${filteredRows.length} rows): ` + error.response.data;
      const parsedErrors = parseErrorMessages(error.response.data);
      if (parsedErrors.length > 1) {
        showError(errorMessage, parsedErrors);
      } else {
        showError(errorMessage);
      }
    } else if (error.request) {
      showError(`${fileTypeLabel} Data Upload failed (${filteredRows.length} rows): No response received`);
    } else {
      showError(`${fileTypeLabel} Data Upload failed (${filteredRows.length} rows): ` + (error.message || 'Unknown error'));
    }
  } finally {
    setIsUploading(false);
  }
};

export default handleJsonUpload;
